import { render, staticRenderFns } from "./siswa.vue?vue&type=template&id=e23b8736&"
import script from "./siswa.vue?vue&type=script&lang=js&"
export * from "./siswa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports